<template>
  <section class="default-layout">
    <AppHeader />
    <main @keydown="cheatActivate($event)">
      <router-view />
    </main>

    <AppFooter />
  </section>
</template>

<script>
import AppHeader from '@/layouts/components/AppHeader'
import AppFooter from '@/layouts/components/AppFooter'
import { bus } from '@/main'

export default {
  name: 'DefaultLayout',
  components: {
    AppHeader,
    AppFooter,
  },
  methods: {
    cheatActivate(e) {
      let KEY = [76, 79, 71, 73, 78]
      this.INPUT = this.INPUT || []
      this.INPUT.push(e.keyCode)

      if (this.INPUT.some((e, i) => KEY[i] != e))
        this.INPUT = [this.INPUT.pop()]
      else if (this.INPUT.length == KEY.length) {
        bus.$emit('openAuth', 'authState', true)
        this.INPUT = []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.default-layout {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: min-content 1fr min-content;
}

main > div {
  min-height: 100%;
  height: 100%;
}
</style>
